module.exports = __webpack_public_path__ + "img/paint-x-white.5b68f3d4.svg";